export const VIDEO_URLS = [
  {
    videoID: '5y3z4uDRFNo',
    title: 'Saquon Big Game (Super Bowl 2025)',
    thumbnail: 'https://assets.cure.com/img/main-site/webp/saquon_big_game.webp'
  },
  {
    videoID: 'NqjQYhpFWAk',
    title: 'Saquon Barkley - MVP',
    thumbnail: 'https://assets.cure.com/img/main-site/webp/saquon-barkley-mvp.webp'
  },
  {
    videoID: 'Co033B-7VXA',
    title: 'Jared Goff (Super Bowl 2024)',
    thumbnail: 'https://assets.cure.com/img/main-site/png/image001.png'
  },
  {
    videoID: '37QECBDg93Q',
    title: 'Cade Cunningham (Super Bowl 2022)',
    thumbnail: 'https://assets.cure.com/img/main-site/cades-biggest-challenge-tn-resized.webp'
  },
  {
    videoID: 'GUMFUGpUj3k',
    title: 'Real Savings (Super Bowl 2022)',
    thumbnail: 'https://assets.cure.com/img/main-site/real-savings-on-michigan-car-insurance-tn-resized.webp'
  },
  {
    videoID: '_dYd-o9dqpA',
    title: 'New Michigan Reform Law',
    thumbnail: 'https://assets.cure.com/img/main-site/new-michigan-reform-law-tn-resized.webp'
  },
  {
    videoID: '0wUeU-jusWA',
    title: 'Amon-Ra St. Brown Best Catch',
    thumbnail: 'https://assets.cure.com/img/main-site/png/image002.png'
  },
  {
    videoID: 'Wxtix-AJMOk',
    title: 'Education, Occupation, and Credit Score',
    thumbnail: 'https://assets.cure.com/img/main-site/education-occupation-and-credit-score-tn-resized.webp'
  }
]

export const MEDIA_VIDEO_URLS = [
  {
    videoID: '5y3z4uDRFNo',
    title: 'Saquon Big Game (Super Bowl 2025)',
    thumbnail: 'https://assets.cure.com/img/main-site/webp/saquon_big_game.webp'
  },
  {
    videoID: 'NqjQYhpFWAk',
    title: 'Saquon Barkley - MVP',
    thumbnail: 'https://assets.cure.com/img/main-site/webp/saquon-barkley-mvp.webp'
  },
  {
    videoID: 'Co033B-7VXA',
    title: 'Jared Goff (Super Bowl 2024)',
    thumbnail: 'https://assets.cure.com/img/main-site/png/image001.png'
  },
  {
    videoID: 'GUMFUGpUj3k',
    title: 'Real Savings (Super Bowl 2022)',
    thumbnail: 'https://assets.cure.com/img/main-site/real-savings-on-michigan-car-insurance-tn-resized.webp'
  },
  
]

export const EXTRA_VIDEO_URLS = [
  {
    videoID: '_dYd-o9dqpA',
    title: 'New Michigan Reform Law',
    className: 'new-michigan-reform-law'
  },
  {
    videoID: '_tISmKfW8Ws',
    title: 'Rick Mahorn',
    className: 'rick-mahorns-new-contract'
  },
  {
    videoID: 'IgS2HGBolXc',
    title: 'Civil Society (Super Bowl 2018)',
    className: 'super-bowl-2019'
  },
  {
    videoID: 'GRxZ88UV7Rk',
    title: 'Cheaters (Super Bowl 2018)',
    className: 'keep-eye-on-road'
  },
  {
    videoID: 'sLn7C_mGrM4',
    title: 'Part of the CURE (Credit Scores)',
    className: 'darren-sproles'
  },
  {
    videoID: '5JYLfa4PBpc',
    title: 'Banned Superbowl 2015 - Deflate Gate',
    className: 'commercial-2015'
  },
  {
    videoID: '9BCEr9V4iP8',
    title: 'Uncovering the CURE Advantage',
    className: 'cure-advantage'
  },
  {
    url: 'https://www.youtube.com/user/CureInsurance',
    title: 'View More Ads and Videos',
    className: 'youtube-video'
  }
]

export const MORE_VIDEOS = []
export const THINKING_SECTION_ARRAY = [
  {
    title: 'Can I customize coverage?',
    description:
      'Yes. At CURE, we offer great pricing for every level of car insurance coverage to choose the protection that’s right for you.'
  },
  {
    title: 'What if I have a claim?',
    description:
      'A CURE-assigned claims adjuster provides personal guidance – from appraisal to car rental to repair with convenient digital estimating technology.'
  },
  {
    title: 'How can I pay my bill?',
    description:
      'CURE offers convenient credit card and bank transfer payment options - online, text or over the phone - including autopay and pay by mail.'
  }
]

export const BLOGS_ARRAY = [
  {
    title: 'All New Jersey Drivers Deserve Transparency and Trust',
    link: '/nm/news/driver-deserve-transparency',
    className: 'deserve-transparency',
    content:
      'The author points to several laws that were clearly created to help protect lower income drivers and prevent car insurers from surreptitiously and unfairly discriminating against unsuspecting consumers, but which simply no longer have any teeth. Like most other states that mandate car insurance, the New Jersey legislature has language in place to protect consumers from rating factors that are unfairly discriminatory.'
  },
  {
    title: 'The Half-Pregnant Public Policy on Car Insurance Rates',
    link: '/nm/news/half-pregnant',
    className: 'half-pregnant',
    content:
      'In my recent Law Journal article, "A Dirty Little Secret in Car Insurance: Can lawyers Lead a Change?" I explained the little-known practice of using income proxies in car insurance in New Jersey. Specifically, it brought to light the dirty secret that many of the publicly traded insurance companies, including those with very familiar household names, charge significantly high- er rates to drivers with spotless driving records simply because they have lower paying jobs, are unemployed, or don’t have at least a college degree, a credit score above 700, or own a home.'
  }
]

export const RESPONSIVE_BREAK_POINTS = {
  0: { items: 1 },
  830: { items: 2 },
  1300: { items: 3 }
}

export const RESPONSIVE_VIDEO_BREAK_POINTS = {
  0: { items: 1 },
  830: { items: 1 },
  1300: { items: 1 }
}

export const ROADSIDE_ASSISTANCE_BREAK_POINTS = {
  0: { items: 1 },
  480: { items: 2 },
  768: { items: 3 },
  1024: { items: 5 }
}

export const CAREERS_BREAK_POINTS = {
  0: { items: 1 },
  480: { items: 1 },
  540: { items: 1 },
  768: { items: 1 },
  1024: { items: 3 }
}

export const BETTER_SECTION_ARRAY = [
  {
    title: 'REFERRALS REWARDED',
    description: 'Share the savings and earn rewards with our friends and family program.',
    className: 'real-saving'
  },
  {
    title: '24/7 ROADSIDE',
    description: 'Included with all policies for flat tires, dead batteries and the unexpected.',
    className: 'real-time'
  },
  {
    title: 'VALUABLE DISCOUNTS',
    description: 'Save with good driver, good student and multi-car discounts, to name a few.',
    className: 'real-experience'
  }
]

export const ROADSIDE_ASSISTANCE_ARRAY = [
  {
    className: 'fuel',
    title: 'FUEL DELIVERY',
    description: 'Out of gas? Receive up to 3 gallons and all you pay for is the cost of the fuel.'
  },
  {
    className: 'battery',
    title: 'BATTERY JUMP START',
    description: "Can't find anyone with jumper cables? We'll send someone who does."
  },
  {
    className: 'car-key',
    title: 'LOCKSMITH SERVICE',
    description:
      'Locked your keys in the car? Lockout service will be provided to you. Proper ID required at time of service.'
  },
  {
    className: 'tire',
    title: 'TIRE CHANGE',
    description: 'Got a flat? Keep your hands clean and let us swap the damaged tire with your spare at the scene.'
  },
  {
    className: 'towing',
    title: 'TOWING',
    description: 'Car breakdown and it needs a lift? We’ll cover the tow.  Coverage does not include repair costs.'
  }
]

export const CLAIM_CENTER_AUTO_DAMAGE_FAQ = [
  {
    id: '1',
    question: 'How do I report a claim?',
    answer:
      '<p>A claim may be reported by completing our <a href="/claims/fnol-form"><span>Online Claim Form</span></a>.</p><p style="margin-bottom:2px!important;">You will be asked to provide:</p><p style="margin-bottom:0px!important;"><span style="color: black!important;font-family: raleway;margin-left: 2px;">1.</span> Where the accident occurred;</p><p style="margin-bottom:0px!important;">2. Date and time of the accident;</p><p style="margin-bottom:0px!important;">3. Description of what happened;</p><p><span style="height: 40px;float: left;margin-right: 4px;color: black!important;">4. </span><span style="color: #000!important;">Name of the driver (if a driver was involved in the accident).</span></p><p>Throughout the report, CURE may ask you for additional information, such as contact information for other parties, vehicle locations, property owner information and police report details. This is important and helpful to have as soon as possible, but you can still report your claim without it.</p><p style="color:rgb(55, 105, 152) !important">WHAT HAPPENS NEXT?</p><p>You will be assigned a dedicated CURE claims representative and can expect to hear from them within 1-2 business days. They will help you navigate through the claims process and be available to answer any questions.</p>'
  },
  // {
  //   id: '2',
  //   question: 'How will CURE inspect my vehicle?',
  //   answer:
  //     '<p style="margin-bottom:2px!important">CURE has a variety of inspection choices available. We offer:</p><ul style="list-style:disc;margin-left:24px;margin-bottom: 15px;"><li>Quick Estimate - virtual inspections allow you to submit photos of your damage just minutes after reporting the claim.</li><li>Drive-in inspections at one of our <a href="/find-repair-shops">Direct Repair Shops</a>.</li><li>Appraisers who can inspect your vehicle at home, at work or at a shop of your choosing.</li></ul>'
  // },
  {
    id: '3',
    question: 'Do I have to get my vehicle repaired?',
    answer:
      '<p>Your vehicle, your choice. Upon receipt of the estimate, you have the option to get the vehicle repaired or receive payment for the repairs and fix the vehicle at your convenience. If your vehicle is financed or leased, the lienholder may require that the vehicle be repaired or that the check be in your name as well as the lienholder’s name.</p><p>If there is any additional damage found by the repair shop, the CURE appraiser will reinspect the vehicle and provide an updated estimate.</p><p>As a CURE insured, you may choose any auto repair shop or use one of our <a href="/find-repair-shops">Direct Repair Shops</a>.</p><p style="margin-bottom:2px!important">CURE Direct Repair Shop Benefits:</p><ul class="ul-hyphen"><li>Efficient claims processing</li><li>Worry-free towing and storage charges</li><li>Highest standards of quality, workmanship, and customer service</li></ul><p> Once the vehicle is repaired, you will pay your deductible directly to the shop.</p>'
  },
  {
    id: '4',
    question: 'Should I file a claim if I have glass or windshield damage?',
    answer:
      '<p>You can file a glass claim with Safelite® AutoGlass by calling <a class="faq-panel-Auto-Damage-mobile" href="tel:+18776648931"><span>877-664-8931</span></a><a class="faq-panel-Auto-Damage-desktop"><span>877-664-8931</span></a>.</p><p>CURE works directly with Safelite® AutoGlass. If damage to your glass is in the form of a chip and is minor, it can be repaired without applying your deductible. Safelite® will bill CURE directly for the cost of the repair. If a windshield needs to be replaced, your "other than collision" deductible will apply. If the cost to replace the windshield exceeds your deductible, Safelite® would bill CURE for the amount above your deductible.</p><p>When asked for your claim number, please provide Safelite® with your policy number and the date of the loss.</p>'
  },
  {
    id: '5',
    question: 'Am I eligible for a rental?',
    answer:
      '<p>Yes, you will be eligible if rental coverage was purchased on your policy, up to the limits selected. The CURE claims representative will connect you with one of our preferred rental companies to arrange for a rental vehicle while your vehicle is being repaired or if it is not drivable.</p>'
  },
  {
    id: '6',
    question: 'What if my vehicle is a total loss?',
    answer:
      '<p>An inspection of the vehicle will be done by a CURE-assigned appraiser to determine the extent of the damage and to consider if it will be a total loss.</p><p>CURE factors in the vehicle’s year, make, model, mileage, condition, and options when making this determination and the value of the vehicle. Once determined, payment may be issued to you and/or your lienholder for the value minus the deductible.</p><p style="margin-bottom:8px"></p><p style="margin-top:8px;margin-bottom:8px!important">Do I need to complete any paperwork?</p><p style="margin-bottom:2px!important">Yes. The following may be required as the laws vary by state:</p><ul style="list-style:disc;margin-left:24px"><li><p style="margin:0!important;">Odometer Disclosure Statement:<ul style="list-style:circle;margin-left:24px;width:auto;margin-right:2px;"><li><p style="margin:0!important;">This confirms the mileage of the vehicle at the time of the accident.</p></li></ul></li><li><p style="margin:0!important;">Power of Attorney:</p><ul style="list-style:circle;margin-left:24px;;width:auto;margin-right:5px;"><li><p style="margin:0!important;">This allows us to transfer the title, we will dispose of your totaled vehicle and comply with the local laws and regulations.</p></li></ul><li style=";width:auto;margin-right:2px;">If the vehicle is owned, you need to locate the title.</li><ul style="list-style:circle;margin-left:24px;width: auto;"><li><p style="margin:0!important;">Consult with your CURE claims representative to discuss the transfer of title.</p></li></ul></li></ul>'
  },
  {
    id: '7',
    question: 'How does CURE determine the value of my vehicle?',
    answer:
      '<p>After evaluating the damages to the vehicle, CURE will reimburse you and/or your lienholder for its actual cash value (ACV), which considers factors such as the year, make, model, mileage, condition, and options. CURE uses a third-party service to conduct a market survey to determine the ACV.</p>'
  },
  {
    id: '8',
    question: 'Can I keep my totaled vehicle?',
    answer:
      '<p>If you own the vehicle, you will have the option to keep the vehicle, but each state has different laws pertaining to this. Consult with your CURE claims representative to further discuss this option.</p>'
  },
  {
    id: '9',
    question: 'Who pays off my loan?',
    answer:
      '<p>CURE will make payment directly to you or your lienholder. If the vehicle’s actual cash value (ACV) is less than the loan, you are responsible for the difference.</p>'
  },
  {
    id: '10',
    question: 'Will my insurance be transferred to a new vehicle?',
    answer:
      '<p>No. You can make the change through <a href="/my-account">My Account</a> or you can contact the CURE Customer Relations Center at <a class="faq-panel-Auto-Damage-mobile" href="tel:+18005352873"><span>800-535-CURE(2873)</span></a><a class="faq-panel-Auto-Damage-desktop"><span>800-535-CURE(2873)</span></a> when adding a new vehicle.</p>'
  }
]

export const CLAIM_CENTER_NJ_MEDIAL_FAQ = [
  {
    id: '1',
    question: 'Where can providers submit bills and post-service appeals?',
    answer:
      '<p class="faq-panel-Auto-Damage-medical-bills">BILLS:</p><p class="faq-panel-Auto-Damage-medical-mails">Mail:</p><p>Medlogix</p><p>300 American Metro Boulevard</p><p>Suite 220</p><p>Hamilton, NJ 08619</p><p class="faq-panel-Auto-Damage-medical-mails">Fax:</p><p><span> 856-552-1999</span></p><p class="faq-panel-Auto-Damage-medical-mails postal-bold">POST-SERVICE APPEALS:</p><p>For the New Jersey post-service appeal form, <a rel="noreferrer" target="_blank" href="https://www.state.nj.us/dobi/pipinfo/postserviceappeal_170208.pdf">click here</a>.</p>'
  },
  {
    id: '2',
    question: 'Where can providers submit Decision Point Review (DPR)/Pre-Certification Requests and Appeals?',
    answer:
      '<p class="faq-panel-Auto-Damage-medical-mails">Mail:</p><p>Medlogix</p><p>300 American Metro Boulevard</p><p>Suite 220</p><p>Hamilton, NJ 08619</p><p class="faq-panel-Auto-Damage-medical-mails">Fax:</p><p><span> 856-910-2501</span></p><p>For the New Jersey pre-service appeal form, <a rel="noreferrer" target="_blank" href="https://www.state.nj.us/dobi/pipinfo/preserviceappeal_170208.pdf">click here</a>.</p>'
  },
  {
    id: '3',
    question: 'How can I request a copy of a PIP ledger or an insured’s declarations pages?',
    answer:
      '<p>All requests must be submitted to <a class="faq-panel-Auto-Damage-mobile" href="tel:+16095200097"><span>609-520-0097</span></a><a class="faq-panel-Auto-Damage-desktop"><span>609-520-0097</span></a>. Please be sure to include the claimant’s name, claim number, policy number, and the date of loss on your request.</p>'
  },
  {
    id: '4',
    question: 'PIP Rules and Forms',
    answer:
      '<p style="margin-bottom:12px">The following two documents apply to all claims with a date of loss after September 27, 2017.</p><p style="margin-bottom: 12px"><a style="font-size:18px; display: flex;align-items:center;" rel="noreferrer" target="_blank" href="https://assets.cure.com/pdf/DPRP-Post-9-17.pdf" class="pdf-text"><img alt="pdflink" class="pdfLink"/><span style="margin-left:4px;vertical-align: middle">Decision Point Review Plan Notice for Insureds and Providers</span></a></p><p style="margin-bottom: 12px"><a style="font-size:18px; display: flex;align-items:center;" rel="noreferrer" target="_blank" href="https://assets.cure.com/pdf/DPRP Special Notice  09 17.pdf" class="pdf-text"><img alt="pdflink" class="pdfLink"/><span style="margin-left:4px;vertical-align: middle">DPRP Special Notice</span></a></p><p style="margin-bottom:12px">The following two documents apply to all claims with a date of loss between April 17, 2017 - September 27, 2017.</p><p style="margin-bottom: 12px"><a style="font-size:18px; display: flex;align-items:center;" rel="noreferrer" target="_blank" href="https://assets.cure.com/pdf/DPRP-4-17-9-17.pdf" class="pdf-text"><img alt="pdflink" class="pdfLink"/><span style="margin-left:4px;vertical-align: middle">Decision Point Review Plan Notice for Insureds and Providers</span></a></p><p style="margin-bottom: 12px"><a style="font-size:18px; display: flex;align-items:center;" rel="noreferrer" target="_blank" href="https://assets.cure.com/pdf/DRP Special Notice Effective April 17 2017.pdf" class="pdf-text"><img alt="pdflink" class="pdfLink" /><span style="margin-left:4px;vertical-align: middle">DPRP Special Notice</span></a></p><p style="margin-bottom:12px">The following documents are for all policies, regardless of date.</p><p style="margin-bottom: 12px"><a style="font-size:18px; display: flex;align-items:center;" rel="noreferrer" target="_blank" href="https://assets.cure.com/pdf/APTP_20160415.pdf" class="pdf-text"><img alt="pdflink" class="pdfLink"/><span style="margin-left:4px;vertical-align: middle">Attending Provider Treatment Plan Form</span></a></p><p style="margin-bottom: 12px"><a style="font-size:18px; display: flex;align-items:center;" rel="noreferrer" target="_blank" href="https://assets.cure.com/pdf/CURE_AONI.pdf" class="pdf-text"><img alt="pdflink" class="pdfLink"/><span style="margin-left:4px;vertical-align: middle">Affidavit of No Insurance</span></a></p><p style="margin-bottom: 12px"><a style="font-size:18px; display: flex;align-items:center;" rel="noreferrer" target="_blank" href="https://assets.cure.com/pdf/NJ_Attending_Physicians_Report.pdf"  class="pdf-text"><img alt="pdflink" class="pdfLink"/><span style="margin-left:4px;vertical-align: middle">Attending Physician&apos;s Report</span></a></p><p style="margin-bottom: 12px"><a style="font-size:18px; display: flex;align-items:center;" rel="noreferrer" target="_blank" href="https://assets.cure.com/pdf/ApplicationForPIPBenefits.pdf" class="pdf-text"><img alt="pdflink" class="pdfLink"/><span style="margin-left:4px;vertical-align: middle">PIP Application</span></a></p>'
  }
]

export const CLAIM_CENTER_MI_MEDIAL_FAQ = [
  {
    id: '1',
    question: 'Where can providers submit bills and post-service appeals?',
    answer:
      '<p class="faq-panel-Auto-Damage-medical-bills">BILLS:</p><p class="faq-panel-Auto-Damage-medical-mails">Mail:</p><p>Medlogix</p><p>300 American Metro Boulevard</p><p>Suite 220</p><p>Hamilton, NJ 08619</p><p class="faq-panel-Auto-Damage-medical-mails">Fax:</p><p><span> 856-552-1999</span></p><p class="faq-panel-Auto-Damage-medical-mails postal-bold">POST-SERVICE APPEALS:</p><p>For the Michigan post-service appeal form, <a rel="noreferrer" target="_blank" href="https://www.michigan.gov/documents/difs/FIS_2356_709652_7.pdf">click here</a>.</p>'
  },
  {
    id: '2',
    question: 'Where can providers submit Decision Point Review (DPR)/Pre-Certification Requests and Appeals?',
    answer:
      '<p>There is no pre-certification requirement for any treatment nor is there a pre-certification appeals process.</p>'
  },
  {
    id: '3',
    question: 'How can I request a copy of a PIP ledger or an insured’s declarations pages?',
    answer:
      '<p>All requests must be submitted to <a class="faq-panel-Auto-Damage-mobile" href="tel:+16095200097"><span>609-520-0097</span></a><a class="faq-panel-Auto-Damage-desktop"><span>609-520-0097</span></a>. Please be sure to include the claimant’s name, claim number, policy number, and the date of loss on your request.</p>'
  },
  {
    id: '4',
    question: 'PIP Rules and Forms',
    answer:
      '<p style="margin-bottom: 12px"><a style="font-size:18px; display: flex;align-items:center;" rel="noreferrer" target="_blank" href="https://assets.cure.com/pdf/Personal Injury Protection Endorsement.pdf" class="pdf-text"><img alt="pdflink" class="pdfLink"/><span style="margin-left:4px;vertical-align: middle;">PIP Endorsement</span></a></p><p style="margin-bottom: 12px"><a style="font-size:18px; display: flex;align-items:center;" rel="noreferrer" target="_blank" href="https://assets.cure.com/pdf/Attendant Care Disability Cert and Affidavit of Attendant Care Services.pdf" class="pdf-text"><img alt="pdflink" class="pdfLink" style="display: inline-block;float: left;margin-right: 2px;"/><span style="margin-left:4px;vertical-align: middle;display:flex;">Attendant Care Disability Cert and Affidavit of Attendant Care Services</span></a></p><p><a style="font-size:18px; display: flex;align-items:center;" rel="noreferrer" target="_blank" href="https://assets.cure.com/pdf/MI_PIP_Application.pdf" class="pdf-text"><img alt="pdflink" class="pdfLink"/><span style="margin-left:4px;vertical-align: middle">PIP Application</span></a></p>'
  }
]

export const CLAIM_CENTER_PA_MEDIAL_FAQ = [
  {
    id: '1',
    question: 'Where can providers submit bills and post-service appeals?',
    answer:
      '<p class="faq-panel-Auto-Damage-medical-bills">BILLS:</p><p class="faq-panel-Auto-Damage-medical-mails">Mail:</p><p>Medlogix</p><p>300 American Metro Boulevard</p><p>Suite 220</p><p>Hamilton, NJ 08619</p><p class="faq-panel-Auto-Damage-medical-mails">Fax:</p><p><span> 856-552-1999</span></p><p class="faq-panel-Auto-Damage-medical-mails postal-bold">POST-SERVICE APPEALS:</p><p>There is no post-service appeal requirement in Pennsylvania.</p>'
  },
  {
    id: '2',
    question: 'Where can providers submit Decision Point Review (DPR)/Pre-Certification Requests and Appeals?',
    answer:
      '<p>There is no pre-certification requirement for any treatment nor is there a pre-certification appeals process.</p>'
  },
  {
    id: '3',
    question: 'How can I request a copy of a Medical Benefits ledger or an insured’s declarations pages?',
    answer:
      '<p>All requests must be submitted to <a class="faq-panel-Auto-Damage-mobile" href="tel:+16095200097"><span>609-520-0097</span></a><a class="faq-panel-Auto-Damage-desktop"><span>609-520-0097</span></a>. Please be sure to include the claimant’s name, claim number, policy number, and the date of loss on your request.</p>'
  },
  {
    id: '4',
    question: 'Medical Benefits Rules and Forms',
    answer:
      '<p style="margin-bottom: 12px"><a style="font-size:18px; display: flex;align-items:center;" rel="noreferrer" target="_blank" href="https://assets.cure.com/pdf/CURE PA PIP Application.pdf" class="pdf-text"><img alt="pdflink" class="pdfLink"/><span style="margin-left:4px;vertical-align: middle">Medical Benefits Application</span></a></p>'
  }
]

export const EMPLOYEES_VIDEO = [
  {
    url: 'https://vimeo.com/541801417/cb6a1ec1a3',
    employeeName: 'Denise Guest',
    employeeRole: 'Underwriting & SIU Manager'
  },
  {
    url: 'https://vimeo.com/541752083/31d98d96a8',
    employeeName: 'Candace Vigo',
    employeeRole: 'Senior Account Advisor'
  },
  {
    url: 'https://vimeo.com/541847591/4ff47378eb',
    employeeName: "Michael O'Shaughnessy",
    employeeRole: 'Claims Representative'
  }
]

const origin = typeof window !== 'undefined' ? window.location.origin : '';

export const NEWS_LIST = [
  {
    title: 'CURE Hackathon 2025 - Where Your Insights Shape Your Innovation',
    date: 'March 13, 2025',
    href: origin+'/nm/news/cure-hackathon',
    isExternal: true,
    description:
      'CURE, CIO and Head of Digital Transformation Doug Benalan, recently led the first in a series of interactive events - the initial entitled: "CURE Hackathon 2025: Where Your Insights Shape the Innovation.” The successful gathering provided a platform for...'
  },
  {
    title: 'Credit, Education Could Mean You Pay More for Car Insurance in NJ. Is It Discriminatory?',
    date: 'Northjersey.com - January 14, 2022',
    href: 'https://www.northjersey.com/story/news/new-jersey/2022/01/14/nj-car-insurance-rates-credit-score-education-race/8895572002/',
    isExternal: true,
    description:
      'By the time Cuqui Rivera had to renew her car insurance policy in December 2019, the longtime activist had only heard about some of the reasons she a Hispanic female with a high school diploma may pay more than her white, college-educated neighbors.'
  },
  {
    title: 'Under New Michigan No-Fault Rules, Drivers Save, Accident Victims Worry',
    date: 'Detroit Free Press - November 27, 2021',
    href: 'https://www.freep.com/story/money/business/2021/11/27/drivers-savings-no-fault-victims-worry/8670083002/?gnt-cfr=1',
    isExternal: true,
    description:
      "Michigan's recent overhaul of its no-fault auto insurance system is gradually saving money for the state's 7.1 million licensed drivers, although its cost-containment mechanisms are making life more precarious for some of the roughly 6,600 people receiving long-term care for the most catastrophic car accident injuries."
  },
  {
    title: 'CURE CEO Eric S. Poe Speaks on the Request to Refund Insurance Surplus to Michiganders',
    date: 'WJR - November 2, 2021',
    href: 'https://www.wjr.com/2021/11/02/whitmer-sends-request-to-refund-insurance-surplus-to-michiganders-though-a-refund-is-already-coming/',
    isExternal: true,
    description:
      'Governor Gretchen Whitmer sent a letter to the Michigan Catastrophic Claims Association (MCCA), requesting to return a $5 billion dollar surplus to every Michigan resident with auto insurance through “refund checks.” The association’s surplus has risen from $2.4 billion at the end of 2020 to $5 billion as of June 30.'
  },
  {
    title: 'CURE Auto Insurance Implements Guidewire InsuranceNow and Predictive Analysis',
    date: 'October 28, 2021',
    href: 'https://www.guidewire.com/about-us/news-and-events/press-releases/20211028/cure-auto-insurance-implements-guidewire-insurancenow-and-predictive/',
    isExternal: true,
    description:
      'Citizens United Reciprocal Exchange (CURE) and Guidewire Software, Inc. (NYSE: GWRE) today announced that CURE has successfully implemented Guidewire InsuranceNow and Predictive Analytics to increase business agility and enable faster speed-to-market for state expansions and integration module additions. The company implemented InsuranceNow to its auto line of business in the state of Michigan, and has begun implementation in the states of New Jersey and Pennsylvania.'
  },
  {
    title: "The Newest Piston Teams Up with Michigan's Newest Car Insurer - Cade Cunningham and CURE",
    date: 'October 8, 2021',
    href: 'https://www.prnewswire.com/news-releases/the-newest-piston-teams-up-with-michigans-newest-car-insurer---cade-cunningham-and-cure-auto-insurance-all-stars-in-the-making-301396267.html',
    isExternal: true,
    description:
      "CURE auto insurance, a not-for-profit car insurer that entered the Michigan market in July, has signed the newest Detroit Piston and number one pick Cade Cunningham. The multi-year endorsement is just the latest in a number of alliances with the basketball team, including its branding of the Detroit Pistons' new courtside club and press conference partner. It also comes on the heels of CURE teaming with former all-time great basketball player and current radio analyst, Rick Mahorn, earlier this year. Since entering the state, CURE has already been making a difference in how car insurance is charged in Michigan.  With the new reform law, drivers have seen savings over 60% and help Michigan drivers who had been paying the highest cost for car insurance in the U.S."
  },
  {
    title: 'All New Jersey Drivers Deserve Transparency and Trust',
    date: 'New Jersey Law Journal - September 20, 2021',
    href: 'https://www.cure.com/nm/news/driver-deserve-transparency',
    isExternal: true,
    className: 'deserve-transparency',
    description:
      'The author points to several laws that were clearly created to help protect lower income drivers and prevent car insurers from surreptitiously and unfairly discriminating against unsuspecting consumers, but which simply no longer have any teeth.'
  },
  {
    title: 'The Half-Pregnant Public Policy on Car Insurance Rates',
    date: 'New Jersey Law Journal - August 2, 2021',
    href: 'https://www.cure.com/nm/news/half-pregnant',
    isExternal: true,
    className: 'half-pregnant',
    description:
      'In my recent Law Journal article, "A Dirty Little Secret in Car Insurance: Can lawyers Lead a Change?" I explained the little-known practice of using income proxies in car insurance in New Jersey. Specifically, it brought to light the dirty secret that many of the publicly traded insurance companies, including those with very familiar household names, charge significantly high- er rates to drivers with spotless driving records simply because they have lower paying jobs, are unemployed, or don\'t have at least a college degree, a credit score above 700, or own a home.'
  },
  {
    title:
      'Former Piston Rick Mahorn Chooses CURE Auto Insurance, the Newest Car Insurer in Michigan, as His New Brand',
    date: 'July 20, 2021',
    href: 'https://www.prnewswire.com/news-releases/former-piston-rick-mahorn-chooses-cure-auto-insurance-the-newest-car-insurer-in-michigan-as-his-new-brand-301337922.html',
    isExternal: true,
    description:
      "On the heels of its launch into Michigan, CURE auto insurance, a not-for-profit car insurer, who has just announced its branding of the Detroit Pistons' new courtside club and press conference partner, has teamed up with former all-time great basketball player, Rick Mahorn, to power forward its presence in the state. The current radio analyst for the Detroit Pistons has become the company's new brand ambassador. Once coined the \"Baddest Bad Boy of them all,\" Mahorn has become a pillar of the community and supporter of the hard-working residents of Michigan. CURE auto insurance's history for defending consumer rights and lowering rates for drivers in Michigan was an easy marriage for the two parties as they found a common interest – to help Michigan drivers no longer pay the highest cost for car insurance in the U.S."
  },
  {
    title: 'Pistons Unveil Plans for Courtside Club at Little Caesars Arena',
    date: 'The Detroit News - July 18, 2021',
    isExternal: true,
    href: 'https://www.detroitnews.com/story/business/2021/07/18/pistons-unveil-plans-courtside-club-little-caesars-arena/8007569002',
    description:
      "What's being billed as a first-of-its-kind courtside club with a bar that offers select liquors, a house beer and an appetizer-style menu will be a new fixture at Detroit Pistons games. The CURE Insurance Courtside Club will be behind a basketball hoop near the visitors' bench. Renderings of the club show high-top tables with no chairs. The club will be open to people with courtside seats, which are some of the most expensive game tickets. It will also be open during Pistons networking and brand-partner events."
  },
  {
    title: 'A Dirty Little Secret in Car Insurance: Can Lawyers Lead a Change?',
    date: 'New Jersey Law Journal - July 12, 2021',
    isExternal: true,
    href: 'https://www.cure.com/nm/news/insurance-courtside-club',
    description:
      'You may be wondering why, amid intricate legal issues to discuss, is there an article on car insurance? Simple really — there’s a dirty little secret that needs to come to light. You probably know that to drive in New Jersey, you must carry car insurance. What you may not know is that even if you have a perfect driving record, New Jersey car insurance companies can charge you more if you don’t have a college education, if you work in a blue-collar job, if you rent your home, or if your credit score isn’t perfect.'
  },
  {
    title: "New Michigan Auto Insurer Doesn't Use Credit Scores, Charges Lower Rates",
    date: 'Detroit Free Press - July 9, 2021',
    isExternal: true,
    href: 'https://www.freep.com/story/money/business/2021/07/09/michigan-cure-auto-insurance-credit-scores/7880516002/?utm_source=freep-Daily',
    description:
      'Until last week, Patrick Palmer was paying an average of $295 a month to insure his 2008 Chevy Trailblazer. Even though he has a good driver discount, the 53-year-old Detroit resident admits to having a poor credit history, and credit history is typically a big factor in auto insurance rates in Michigan, especially high-cost urban areas like Detroit.'
  },
  {
    title: 'CURE Auto Insurance Launches in Michigan',
    date: 'July 1, 2021',
    href: 'https://www.prnewswire.com/news-releases/cure-auto-insurance-launches-in-michigan-301324832.html',
    isExternal: true,
    description:
      'CURE auto insurance, a not-for-profit car insurer doing business in New Jersey and Pennsylvania, announces it has been granted a license to expand into Michigan starting July 2, 2021, when the latest no-fault reforms take effect.  CURE announced its studies project a savings of up to 50% from Michiganders current rates.  Most notably, CURE refuses to use credit scores to rate drivers.  As part of its expansion, CURE has plans for a new location in Detroit with 100-200 employees.'
  },
  {
    title: 'CURE CEO Eric S. Poe Speaks on New Changes to Michigan’s Auto Insurance Starts July 1, 2021',
    date: 'CBS Detroit - June 29, 2021',
    href: 'https://detroit.cbslocal.com/2021/06/29/new-changes-to-michigans-auto-insurance-starts-july-1-2021/',
    isExternal: true,
    description:
      'In May of 2019 Governor Whitmer signed into legislation a No-Fault auto insurance reform in an effort to address high premiums, and to lower costs for Michigan Drivers. That new policy goes into effect this week. “Right now starting July 1st will be the largest change in the car insurance law in the history of Michigan,” said Eric S. Poe CEO of CURE Auto Insurance.'
  },
  {
    title: 'CURE CEO Eric S. Poe Answers "Is It Time to Shop Around for Better Car Insurance?"',
    date: 'ClickOnDetroit - June 24, 2021',
    href: 'https://www.clickondetroit.com/live-in-the-d/2021/06/24/is-it-time-to-shop-around-for-better-car-insurance/',
    isExternal: true,
    description:
      'Between the lifting of COVID restrictions, returning to work, and summer vacations, more people are climbing behind the wheel and hitting the roads. To help make those trips less stressful, it’s nice to know you have the right car insurance, that’s affordable and fits your budget. This allows you to have more money in your pocket to pay other bills or enjoy that vacation a little more. Jason Carr spoke with Eric S. Poe, CEO of Cure Auto Insurance, about how to stay protected during your next road trip.'
  },
  {
    title: 'CURE CEO Eric S. Poe Discusses Discrimination in Car Insurance',
    date: 'PBS WHYY - June 6, 2021',
    href: 'https://www.pbs.org/video/pathway-to-success-ep-3-discrimination-in-auto-insurance-dkqafz/',
    isExternal: true,
    description:
      'John E. Harmon, Sr., Founder, Pres. & CEO of African American Chamber of Commerce of NJ, and Eric S. Poe, COO of Cure Auto Insurance, discuss disparities in auto insurance premium costs and a bill to prohibit insurers from using certain income and education proxies to set insurance rates and eligibility. Produced by the AACCNJ, Pathway to Success highlights the African American business community.'
  },
  {
    title: 'CURE Auto Insurance Selects Guidewire InsuranceNow to Accelerate Speed-to-Market and Business Growth',
    date: 'April 29, 2021',
    href: 'https://www.nasdaq.com/press-release/cure-auto-insurance-selects-guidewire-insurancenow-to-accelerate-speed-to-market-and',
    isExternal: true,
    description:
      'Citizens United Reciprocal Exchange (CURE), a not-for-profit full service provider of auto insurance licensed in New Jersey, Pennsylvania, and Michigan, and Guidewire Software, Inc. (NYSE: GWRE), the platform P&C insurers trust to engage, innovate, and grow efficiently, today announced that CURE has selected InsuranceNow and Predictive Analytics to accelerate speed-to-market and business growth. The company plans to begin implementing InsuranceNow for their greenfield personal auto line of business in the state of Michigan, followed by their auto insurance lines of business in New Jersey and Pennsylvania.'
  },
  {
    title: 'Do Auto Insurance Rates Discriminate Against People of Color?',
    date: 'November 2, 2020',
    isExternal: true,
    href: 'https://www.roi-nj.com/2020/11/02/finance/car-wars-sponsors-of-bills-and-their-champion-cures-eric-poe-target-factors-in-auto-insurance-rates-they-say-are-discriminatory',
    description:
      'Gov. Phil Murphy was very deliberate with his words and actions last week regarding the rollout of a potential COVID-19 vaccine in the state. The distribution will be equitable for all communities, he said. The plan was not thrown together — it is a product of months of collaboration, he said. The hope, Murphy said, is that the state will be able to successfully vaccinate two-thirds of its adult population.'
  },
  {
    title:
      'Eric S. Poe of CURE Auto Insurance: 5 Steps We Must Take to Truly Create an Inclusive, Representative, and Equitable Society',
    date: 'Authority Magazine - October 15, 2020',
    isExternal: true,
    href: 'https://medium.com/authority-magazine/eric-s-poe-of-cure-auto-insurance-5-steps-we-must-take-to-truly-create-an-inclusive-representativ-51052f4838ab',
    description:
      'The author would turn to youth for the building of future leaders. One of the many lessons we have been reminded of in the past several months is the need to provide children with the tools they need to manage during tumultuous times. One tool that could prove useful would be to expand the current health curriculum in schools to include an aspect of “mental” well-being rooted in the concept of mindfulness. From a very young age, children need to be armed with understanding how to handle stress, conflict, and interpersonal relationships, while also becoming more comfortable with themselves.'
  },
  {
    title: 'Need for Transparency',
    date: 'New Jersey Law Journal - August 21, 2020',
    isExternal: true,
    href: 'https://assets.cure.com/pdf/nm/NJLJ08242020458318.pdf',
    description:
      'Transparency is one of the most prevalent words used in corporate mission statements today. It can be argued that a company’s perceived truthfulness and open communication with consumers can make or break the business. But what happens when the public is required by law to buy a product that does not come with transparency? That sce- nario, unacceptable to most, is hap- pening in the world of car insurance, here in New Jersey—and nationwide.'
  }
]

export const REPAIR_SHOPS_RESULTS = [
  {
    name: 'Autocrafters',
    address: '2659 Bristol Pike',
    city: 'Bensalem',
    state: 'Pennsylvania',
    zipCode: '19020',
    phoneNumber: '(215) 638-2322'
  },
  {
    name: 'Faulkner Buick GMC',
    address: '4427 Street Road',
    city: 'Trevose',
    state: 'Pennsylvania',
    zipCode: '19053',
    phoneNumber: '(215) 364-7720'
  },
  {
    name: 'Faulkner Cadillac',
    address: '2425 Lincoln Highway',
    city: 'Trevose',
    state: 'Pennsylvania',
    zipCode: '19053',
    phoneNumber: '(215) 639-9700'
  },
  {
    name: 'Faulkner Collision',
    address: '1118 Old Bethlehem Pike',
    city: 'Sellersville',
    state: 'Pennsylvania',
    zipCode: '18960',
    phoneNumber: '(267) 450-8700'
  },
  {
    name: 'Team Toyota',
    address: '407 E. Lincoln Highway',
    city: 'Langhorne',
    state: 'Pennsylvania',
    zipCode: '19047',
    phoneNumber: '(215) 741-4200'
  }
]

export const COUNTY_LIST = {
  NJ: [
    'Atlantic',
    'Bergen',
    'Burlington',
    'Camden',
    'Cape May',
    'Cumberland',
    'Essex',
    'Gloucester',
    'Hudson',
    'Hunterdon',
    'Mercer',
    'Middlesex',
    'Monmouth',
    'Morris',
    'Ocean',
    'Passaic',
    'Salem',
    'Somerset',
    'Sussex',
    'Union',
    'Warren'
  ],
  PA: [
    'Adams',
    'Berks',
    'Bucks',
    'Chester',
    'Cumberland',
    'Dauphin',
    'Delaware',
    'Lancaster',
    'Lebanon',
    'Lehigh',
    'Monroe',
    'Montgomery',
    'Northampton',
    'Philadelphia',
    'York'
  ],
  MI: []
}

export const FORMS_DOCUMENTS_POLICY_LIST = {
  NJ: [
    {
      id: '1',
      title: 'Standard Coverage Selection Form',
      link: 'https://assets.cure.com/pdf/forms/Standard_CSF-0223.pdf',
      subText: '(310 KB PDF)',
      content:
        'Fax and return to 877-664-8233. This is not an application for insurance. Please contact CURE at 800-535-CURE (2873) if you are interested in applying.'
    },
    {
      id: '4',
      title: 'Standard Coverage Selection Form',
      link: 'https://assets.cure.com/pdf/NJC-SCSF_01_26.pdf',
      subText: '(210 KB PDF)',
      showSubtext: true,
      content:
        'For policies with effective date on or after 1/1/2026'
    },
    {
      id: '2',
      title: 'Basic Coverage Selection Form',
      link: 'https://assets.cure.com/pdf/NJC-BCSF_02_23.pdf',
      subText: '(200 KB PDF)',
      content:
        'Fax and return to 877-664-8233. This is not an application for insurance. Please contact CURE at 800-535-CURE (2873) if you are interested in applying.'
    },
    {
      id: '3',
      title: "New Jersey Auto Insurance Buyer's Guide",
      link: 'https://assets.cure.com/pdf/forms/NJC-BG-0123.pdf',
      subText: '(847 KB PDF)',
      content: ''
    },
    {
      id: '5',
      title: "New Jersey Auto Insurance Buyer's Guide",
      link: 'https://assets.cure.com/pdf/NJC-BG_01_26.pdf',
      subText: '(459 KB PDF)',
      showSubtext: true,
      content:
        'For policies with effective date on or after 1/1/2026'
    },
  ],
  PA: [
    {
      id: '1',
      title: 'Tort Option Notice',
      link: 'https://assets.cure.com/pdf/forms/PA-Tort-Option-Notice.pdf',
      subText: '(56 KB PDF)',
      content:
        'Fax and return to 877-664-8233. This is not an application for insurance. Please contact CURE at 800-535-CURE(2873) if you are interested in applying.'
    },
    {
      id: '2',
      title: 'Physical Damage Selection Form',
      link: 'https://assets.cure.com/pdf/forms/PA-PAC-CSF.pdf',
      subText: '(63 KB PDF)',
      content:
        'Fax and return to 877-664-8233. This is not an application for insurance. Please contact CURE at 800-535-CURE(2873) if you are interested in applying.'
    },
    {
      id: '3',
      title: 'Uninsured Motorist Coverage Options Form',
      link: 'https://assets.cure.com/pdf/forms/PA-UMO.pdf',
      subText: '(8 KB PDF)',
      content:
        'Fax and return to 877-664-8233. This is not an application for insurance. Please contact CURE at 800-535-CURE(2873) if you are interested in applying.'
    },
    {
      id: '4',
      title: 'Underinsured Motorist Coverage Options Form',
      link: 'https://assets.cure.com/pdf/forms/PA-UIM.pdf',
      subText: '(8 KB PDF)',
      content:
        'Fax and return to 877-664-8233. This is not an application for insurance. Please contact CURE at 800-535-CURE(2873) if you are interested in applying.'
    }
  ],
  MI: [
    {
      id: '1',
      title: 'Collision Coverage Information Form - Michigan',
      link: 'https://assets.cure.com/pdf/forms/MI-Collision-Coverage.pdf',
      subText: '',
      content: ''
    },
    {
      id: '2',
      title: 'Michigan Choice of Bodily Injury Liability Coverage Limits',
      link: 'https://assets.cure.com/pdf/forms/MI-Choice-Of-Bodily-Injury-Liability-Coverage-Limits.pdf',
      subText: '',
      content: ''
    },
    {
      id: '3',
      title: 'Michigan Selection of Personal Injury Protection (PIP) Medical Coverage – Individual(s)',
      link: 'https://assets.cure.com/pdf/forms/MI-Selection-Of-PIP.pdf',
      subText: '',
      content: 'For policies with effective date prior to 7/1/2023',
      showSubtext: true
    },
    {
      id: '4',
      title: 'Michigan Selection of Personal Injury Protection (PIP) Medical Coverage – Individual(s)',
      link: 'https://assets.cure.com/img/main-site/Revised-PIP-CSF.pdf',
      subText: '',
      content: 'For policies with effective date on 7/1/2023 until 9/28/2025',
      showSubtext: true
    },
    {
      id: '5',
      title: 'Michigan Selection of Personal Injury Protection (PIP) Medical Coverage – Individual(s)',
      link: 'https://assets.cure.com/pdf/MICO770925.pdf',
      subText: '',
      content: 'For policies with effective date on or after 9/29/2025',
      showSubtext: true
    },
    {
      id: '6',
      title: 'Michigan Liability Coverage Limits Selection',
      link: 'https://assets.cure.com/pdf/forms/MI-Liability-Coverage-Limits.pdf',
      subText: '',
      content: ''
    },
  ]
}

export const FORMS_DOCUMENTS_CLAIMS_LIST = {
  NJ: [
    {
      id: '1',
      title: "New Jersey Driver's Report of Accident",
      link: 'https://assets.cure.com/pdf/forms/NJ_drivers_report.pdf',
      subText: '(80 KB PDF)',
      content: ''
    },
    {
      id: '2',
      title: 'Application for PIP Benefits',
      link: 'https://assets.cure.com/pdf/ApplicationForPIPBenefits.pdf',
      subText: '(140 KB PDF)',
      content:
        'Note: This document should be printed on legal size paper (8.5" x 14") Fax and return to the PIP Department at 609-520-0097.'
    },
    {
      id: '3',
      title: "Attending Physician's Report",
      link: 'https://assets.cure.com/pdf/forms/NJ_Attending_Physicians_Report.pdf',
      subText: '(61 KB PDF)',
      content: 'Fax and return to the PIP Department at 609-520-0097.'
    },
    {
      id: '4',
      title: 'Affidavit of No Insurance',
      link: 'https://assets.cure.com/pdf/forms/NJ-Affidavit-Of-No-Insurance2008.pdf',
      subText: '(35 KB PDF)',
      content: 'Fax and return to the PIP Department at 609-520-0097.'
    },
    {
      id: '5',
      title: 'Decision Point Review Plan Notice for Insureds and Providers',
      link: 'https://assets.cure.com/pdf/DPRP-4-17-9-17.pdf',
      subText: '(345 KB PDF)',
      content: 'Applies to all claims with a date of loss between 4/17/17 - 9/27/17.',
      showSubtext: true
    },
    {
      id: '6',
      title: 'Decision Point Review Plan Notice for Insureds and Providers',
      link: 'https://assets.cure.com/pdf/DPRP-Post-9-17.pdf',
      subText: '(182 KB PDF)',
      content: 'Applies to all claims with a date of loss after 9/27/17.',
      showSubtext: true
    },
    {
      id: '7',
      title: 'Attending Provider Treatment Plan Form',
      link: 'https://assets.cure.com/pdf/forms/NJ-APTP.pdf',
      subText: '(20 KB PDF)',
      content: 'Fax and return to the PIP Department at 856-910-2501.'
    }
  ],
  PA: [
    {
      id: '1',
      title: "Pennsylvania Driver's Report of Accident",
      link: 'https://assets.cure.com/pdf/forms/PA_drivers_report.pdf',
      subText: '(84 KB PDF)',
      content: ''
    },
    {
      id: '2',
      title: 'Witness Statement',
      link: 'https://assets.cure.com/pdf/forms/PA-Witness-Statement.pdf',
      subText: '(49 KB PDF)',
      content: ''
    },
    {
      id: '3',
      title: 'Pennsylvania Application for Benefits',
      link: 'https://assets.cure.com/pdf/forms/PA-PIP-APP.pdf',
      subText: '(438 KB PDF)',
      content: ''
    }
  ],
  MI: []
}